import { render, staticRenderFns } from "./MultiSearch.vue?vue&type=template&id=edd2b766&scoped=true&"
import script from "./MultiSearch.vue?vue&type=script&lang=js&"
export * from "./MultiSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd2b766",
  null
  
)

export default component.exports